import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-365b49a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-start add-new" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-1" }, "Add new", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_base_form_validator = _resolveComponent("base-form-validator")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_select, _mergeProps(_ctx.$attrs, {
      placeholder: "Select a add a promotion ID",
      "default-value": _ctx.defaultValue
    }, _toHandlers(_ctx.$listeners), {
      "use-load-more": {url: '/bo/api/v1/promotions', key: 'promotions', firstLoader: _ctx.name == 'five_minutes_promotion_id', active: true, option: {'value': 'id', search: 'search_text', 'title': 'remark', customRender: (id, title) => { return `${id} ` + (title ? '(' + title + ')' : '')} }}
    }), {
      default: _withCtx(() => [
        _createVNode(_component_a_select_option, {
          value: "add new",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCreatePromotion()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_PlusOutlined, { class: "flex-1" }),
              _hoisted_2
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["default-value", "use-load-more"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.$t('module.stream.add_promotion'),
      onOk: _ctx.onSubmitPromotion,
      "confirm-loading": _ctx.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.promotion,
          "validate-messages": _ctx.validateMessages,
          ref: "formPromotion"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_form_validator, {
              label: _ctx.$t('module.stream.create_streamer.promotion_id'),
              name: "id",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.promotion.id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.promotion.id) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_base_form_validator, {
              label: _ctx.$t('module.stream.create_streamer.remark'),
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.promotion.remark,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.promotion.remark) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "validate-messages"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk", "confirm-loading"])
  ], 64))
}